import React, {Component} from 'react';
import classNames from 'classnames';

class CustomSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            isFocused: false,
            selectedOption: this.props.selectedOption
        };

        this.handleKeyboardNavigation = this.handleKeyboardNavigation.bind(this);
        this.handleKeyboardOptionSelection = this.handleKeyboardOptionSelection.bind(this);
        this.handleBtnClick = this.handleBtnClick.bind(this);
        this.handleBtnFocus = this.handleBtnFocus.bind(this);
        this.handleBtnBlur = this.handleBtnBlur.bind(this);
        this.createOptionItem = this.createOptionItem.bind(this);
    }

    componentDidMount() {
        this.bindEventListeners();
    }

    componentWillUnmount() {
        this.unbindEventListeners();
    }

    bindEventListeners() {
        window.addEventListener('keydown', this.handleKeyboardNavigation, false);
    }

    unbindEventListeners() {
        window.removeEventListener('keydown', this.handleKeyboardNavigation, false);
    }

    handleKeyboardNavigation(event) {

        // keyCode 40 - arrow key down
        // keyCode 38 - arrow key up

        if (this.state.isFocused && (event.keyCode === 40 || event.keyCode === 38)) {
            event.preventDefault();
            if (!this.state.isOpen) {
                this.setState({isOpen: true});
            } else {
                this.setOption(event.keyCode);
            }
        }
    }

    setOption(keyCode) {
        const
            options = this.props.options,
            optionsLength = options.length,
            activeOptionIndex = options.indexOf(this.state.selectedOption),
            nextOptionIndex = keyCode === 40 ? activeOptionIndex + 1 : activeOptionIndex - 1;

        if (nextOptionIndex < optionsLength && nextOptionIndex >= 0) {
            this.setState({selectedOption: options[nextOptionIndex]})
        } else if (nextOptionIndex < 0) {
            this.setState({selectedOption: options[0]})
        }
    }

    handleBtnClick() {
        this.setState(prevState => ({
            isOpen: !prevState.isOpen
        }));

    }

    handleBtnFocus() {
        this.setState({
            isFocused: true
        });
    }

    handleBtnBlur() {
        this.setState({
            isOpen: false,
            isFocused: false
        });
    }

    handleOptionSelection(option) {
        this.setState(prevState => ({
            isOpen: !prevState.isOpen,
            selectedOption: option
        }));
        this.props.onValueSelection(option);

    }

    handleKeyboardOptionSelection(event) {

        // keyCode 40 - Enter
        if (event.keyCode === 13 && this.state.isOpen) {
            this.setState({
                isOpen: false,
            });
            this.props.onValueSelection(this.state.selectedOption);
        }
    }

    createOptionItem(option) {
        const optionStyles = classNames(
            'custom-select__item',
            {'custom-select__item--highlighted': option === this.state.selectedOption}
        );

        return (
            <li className={optionStyles}
                role="option"
                key={option}
                id={`${this.props.optionsListName}-${option}`}
                onMouseDown={() => this.handleOptionSelection(option)}
            >
                {option}
            </li>
        )
    }


    render() {
        const
            {optionsListName, options, labelId} = this.props,
            {isOpen, selectedOption} = this.state,
            optionsList = options.map((option) => this.createOptionItem(option)),
            customSelectWidgetStyles = classNames(
                'custom-select__widget',
                {'custom-select__widget--open': isOpen}
            );

        return (
            <div className="custom-select">
                <div className={customSelectWidgetStyles}>
                    <button
                        role="combobox"
                        aria-owns={optionsListName}
                        aria-expanded={isOpen}
                        aria-labelledby={labelId}
                        aria-activedescendant={`${optionsListName}-${selectedOption}`}

                        onMouseDown={this.handleBtnClick}
                        onKeyDown={this.handleKeyboardOptionSelection}
                        onBlur={this.handleBtnBlur}
                        onFocus={this.handleBtnFocus}
                        type="button"
                        className="custom-select__btn">
                        <span className="custom-select__label">{selectedOption}</span>
                    </button>
                    <ul
                        id={optionsListName}
                        className="custom-select__list"
                        role="listbox"
                    >
                        {optionsList}
                    </ul>
                </div>
            </div>
        )
    }
}

export default CustomSelect;